import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getGates(eventId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`events/${eventId}/gates?` + parameters);
  return data;
}

export async function getGate(eventId, id) {
  const { data } = await axios.get(`events/${eventId}/gates/` + id);
  return data;
}

export async function createGate(eventId, values) {
  const { data } = await axios.post(`events/${eventId}/gates`, values);
  return data;
}

export async function updateGate(eventId, id, values) {
  const { data } = await axios.patch(`events/${eventId}/gates/` + id, values);
  return data;
}

export async function deleteGate(eventId, id) {
  const { data } = await axios.delete(`events/${eventId}/gates/` + id);
  return data;
}
